import FeaturesIcon from '@material-ui/icons/PinDrop';
import FeaturesEdit from './featuresEdit';
import FeaturesList from './featuresList';
import FeaturesShow from './featuresShow';

export default {
  edit: FeaturesEdit,
  list: FeaturesList,
  show: FeaturesShow,
  icon: FeaturesIcon,
};
